export default __webpack_public_path__ + "static/media/element_spec_43.82e4befb.webp";